import { useState, ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';

interface AccordionProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  badge?: string | number;
  headerAction?: ReactNode;
}

export function Accordion({
  title,
  children,
  defaultOpen = false,
  badge,
  headerAction,
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border border-border rounded-lg overflow-hidden">
      <div className="w-full flex items-center justify-between px-3 py-2 bg-background-subtle">
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center gap-2 hover:opacity-80 transition-opacity text-left flex-1"
        >
          <ChevronDown
            className={`h-4 w-4 text-foreground-muted transition-transform ${
              isOpen ? 'rotate-180' : ''
            }`}
          />
          <h3 className="text-base font-semibold text-foreground">{title}</h3>
          {badge !== undefined && (
            <span className="px-2 py-0.5 text-xs font-medium bg-primary/10 text-primary rounded-full">
              {badge}
            </span>
          )}
        </button>
        {headerAction && (
          <div onClick={(e) => e.stopPropagation()}>{headerAction}</div>
        )}
      </div>
      {isOpen && <div className="px-3 py-2">{children}</div>}
    </div>
  );
}
